import { ProjectLocationData } from "./ProjectLocationData.model";

/** Konum bilgisini tek noktadan oluşturur, günceller ve API formatına dönüştürür. */
export class ProjectLocationModel implements ProjectLocationData {
    CountryName = '';
    CityName = '';
    CountryCode = '';
    Region = '';
    TimeZone = '';
    Latitude = 0;
    Longitude = 0;
    Ip = '';

    constructor(data: Partial<ProjectLocationData> = {}) { this.update(data); }

    update(data: Partial<ProjectLocationData>): this {
        this.CountryName = data.CountryName ?? this.CountryName;
        this.CityName = data.CityName ?? this.CityName;
        this.CountryCode = data.CountryCode ?? this.CountryCode;
        this.Region = data.Region ?? this.Region;
        this.TimeZone = data.TimeZone ?? this.TimeZone;
        this.Latitude = data.Latitude ?? this.Latitude;
        this.Longitude = data.Longitude ?? this.Longitude;
        this.Ip = data.Ip ?? this.Ip;
        return this;
    }

    setCoordinates(latitude: number, longitude: number): this { this.Latitude = latitude; this.Longitude = longitude; return this; }
    setIp(ip: string): this { this.Ip = ip; return this; }
    clone(): ProjectLocationModel { return new ProjectLocationModel(this); }
    toJSON(): ProjectLocationData { return { CountryName: this.CountryName, CityName: this.CityName, CountryCode: this.CountryCode, Region: this.Region, TimeZone: this.TimeZone, Latitude: this.Latitude, Longitude: this.Longitude, Ip: this.Ip }; }

    static fromCoordinates(latitude: number, longitude: number): ProjectLocationModel { return new ProjectLocationModel().setCoordinates(latitude, longitude); }

    static fromApi(value: unknown): ProjectLocationModel | null {
        if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
        const lat = this.readField(value, ['latitude']);
        const lon = this.readField(value, ['longitude']);
        const latitude = lat == null ? 0 : typeof lat === 'number' ? lat : Number.NaN;
        const longitude = lon == null ? 0 : typeof lon === 'number' ? lon : Number.NaN;
        if (!Number.isFinite(latitude) || !Number.isFinite(longitude) || Math.abs(latitude) > 85.05112878 || Math.abs(longitude) > 180) return null;
        if (lat === undefined && lon === undefined) return null;
        const readText = (names: string[], fallback: string): string => { const field = this.readField(value, names); return typeof field === 'string' ? field : fallback; };
        return new ProjectLocationModel({
            CountryName: readText(['countryName', 'country'], 'Unknow Country'),
            CityName: readText(['cityName', 'city'], 'Unknow City'),
            CountryCode: readText(['countryCode'], 'Unknow Code'),
            Region: readText(['region'], 'Unknow Region'),
            TimeZone: readText(['timeZone'], 'Unknow TimeZone'),
            Latitude: latitude,
            Longitude: longitude,
            Ip: readText(['ip', 'ipAddress'], '')
        });
    }

    private static readField(value: object, names: string[]): unknown {
        const row = value as Record<string, unknown>;
        const key = Object.keys(row).find(item => names.some(name => item.toLowerCase() === name.toLowerCase()));
        return key === undefined ? undefined : row[key];
    }
}
